import { getDefaultTypography } from '../utils'

export const FabDesignSettings = {
  'fab-primary-design-size': {
    phone: 'small',
    'phone-landscape': 'small',
    tablet: 'medium',
    'tablet-landscape': 'medium',
    desktop: 'large',
    tv: 'large',
  },
  'fab-secondary-design-size': {
    phone: 'small',
    'phone-landscape': 'small',
    tablet: 'medium',
    'tablet-landscape': 'medium',
    desktop: 'large',
    tv: 'large',
  },

  'fab-primary-design-shape': {
    phone: 'drop-br',
    'phone-landscape': 'drop-br',
    tablet: 'drop-br',
    'tablet-landscape': 'drop-br',
    desktop: 'drop-br',
    tv: 'drop-br',
  },
  'fab-secondary-design-shape': {
    phone: 'circle',
    'phone-landscape': 'circle',
    tablet: 'circle',
    'tablet-landscape': 'circle',
    desktop: 'circle',
    tv: 'circle',
  },
  'fab-design-h-align': {
    phone: 'end',
    'phone-landscape': 'end',
    tablet: 'end',
    'tablet-landscape': 'end',
    desktop: 'end',
    tv: 'end',
  },

  'fab-primary-design-color-variant': {
    light: 'secondary-30',
    dark: 'secondary-30',
  },
  'fab-secondary-design-color-variant': {
    light: 'tertiary-30',
    dark: 'tertiary-30',
  },

  //* NESTED
  'fab-design-typography': {
    'fab-primary-design-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
    'fab-secondary-design-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
  },
}
